import { NbMenuItem } from '@nebular/theme';

export interface KPMenuItem extends NbMenuItem {
  section?: KPMenuItemSections;
  actionType: 'link' | 'modal' | 'window';
}

export enum KPMenuItemSections {
  EndButtons = 'END_BUTTONS',
  StartButtons = 'START_BUTTONS',
  MidButtons = 'MID_BUTTONS',
  EndSection = 'END_SECTION',
  StartSection = 'START_SECTION',
  MidSection = 'MID_SECTION',
}

export type KPHeaderData = {
  userMenu?: KPMenuItem[];
  headerBrandTitle: string;
};
